const coffeeToggle = () => {
  const coffeeToggleSelector = document.querySelector('#coffeeToggle');

  if (!coffeeToggleSelector) {
    return false;
  }

  coffeeToggleSelector.addEventListener('change', () => {
    const espressoCapsules = document.querySelector('.espresso-capsules');
    const filterCapsules = document.querySelector('.filter-capsules');
    const espressoTitle = document.querySelector('.espresso-title');
    const filterTitle = document.querySelector('.filter-title');
    const coffeeToggleSelectorState = coffeeToggleSelector.checked;

    if (
      !espressoCapsules ||
      !filterCapsules ||
      !espressoTitle ||
      !filterTitle
    ) {
      coffeeToggleSelector.checked = false;
      return false;
    }

    if (coffeeToggleSelectorState) {
      filterTitle.classList.remove('opacity');
      espressoTitle.classList.add('opacity');
      filterCapsules.classList.remove('is-hidden');
      espressoCapsules.classList.add('is-hidden');
    } else {
      filterTitle.classList.add('opacity');
      espressoTitle.classList.remove('opacity');
      filterCapsules.classList.add('is-hidden');
      espressoCapsules.classList.remove('is-hidden');
    }
  });
};

export default coffeeToggle;
